import addElement from '../helpers/addElement';

class HighlightArea {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.renderHighlightAreaOnDrag(task),
        getVisibleRange: instance.getVisibleTasksRange,
      },
      filter(task) {
        return instance.config.show_drag_vertical && task.id == instance.getState().drag_id;
      },
    });
  }

  renderHighlightAreaOnDrag(task) {
    const state = this.instance.getState();
    let copy = this.instance.__scaleTask(task);

    if (state.drag_mode === 'resize') {
      if (state.drag_from_start) {
        copy.start_date = task.start_date;
      }

      if (!state.drag_from_start) {
        copy.end_date = task.end_date;
      }
    } else if (state.drag_mode === 'move') {
      copy = task;
    }

    const sizes = this.instance.getTaskPosition(copy, copy.start_date, copy.end_date);
    const wrapper = document.createElement('div');

    addElement({
      css: 'drag_move_vertical',
      left: `${sizes.left}px`,
      top: 0,
      width: `${sizes.width}px`,
      height: `${this.instance.getVisibleTaskCount() * this.instance.config.row_height}px`,
      wrapper,
    });

    return wrapper;
  }
}

export default new HighlightArea();
